<template>
  <el-dialog :title="title" :visible.sync="show" :destroy-on-close="true" :before-close="closeBox" width="100%" fullscreen v-loading="loading">
    <div style="width: 100%; height: 100%;">
      <div class="w100 pl20 pr20 pt20">
        <div class="title">
          <span>基本信息</span>
          <!-- <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button> -->
        </div>
        <el-form :inline="true" label-width="100px" :model="form" ref="headForm" class="demo-form-inline">
          <el-form-item label="服务类别" style="width: 40%;">
            <el-select style="width: 250px;" v-model="form.serveType" :disabled="disabled" @change="changeServeModule" placeholder="请选择服务类别">
              <el-option v-for="item in this.selectType.data" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务模板" style="width: 40%;">
            <el-select style="width: 250px;" v-model="form.moduleType" :disabled="moduleDisabled" placeholder="请选择服务模板">
              <el-option label="通用模板" value="all"></el-option>
              <el-option v-for="item in selectModule.data" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <component v-bind:is="componentName" ref="formRule" :prorData="prorData" @backFn="getChildData" @closeFn="closeBox"></component>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeBox">关闭窗口</el-button>
      <el-button type="primary" v-if="form.serveType !== '1'" @click="submitForm('ruleForm')">保 存</el-button>
      <el-button type="primary" v-else @click="clickChildFn()">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import IsApprove from "@/components/management/serve/IsApprove"; // 审批类 站内组件
import IsSearch from "@/components/management/serve/IsSearch"; // 查询类 站内组件
import IsOther from "@/components/management/serve/IsOther"; // 公用站外组件

export default {
  name: "Dialog",
  components: {
    IsApprove, // 审批类
    IsSearch, // 查询类
    IsOther, // 其他
  },
  props: ["propData"],
  data() {
    return {
      show: false,
      loading: false,
      disabled: false,
      title: "",
      serveId: "", // 关联到下级组件
      selectType: {
        // 服务类型
        data: [],
      },
      selectObj: {
        data: [],
      },
      selectTheme: {
        data: [],
      },
      selectModule: {
        data: [],
      },
      form: {
        serveType: "0",
        moduleType: "all",
      },
      moduleDisabled: false, // 服务模板选择是否禁用
      prorData: {},
      backData: null,
      infoFrom: {}, // 保存 详情的变量
    };
  },
  computed: {
    // 判断 根据选择的类别 调用不同组件
    // IsApprove : 审批类
    // IsSearch  : 查询类
    // IsOther   : 其他
    // serveType: 0: 查询类; 1:审批类; 9: 其他
    componentName() {
      var _this = this;
      // 传之组件
      _this.prorData = {
        serveId: _this.serveId,
        obj: _this.selectObj.data,
        theme: _this.selectTheme.data,
        infoFrom: _this.infoFrom,
      };
      // 详情的时候
      if (_this.serveId !== "") {
        if (_this.form.serveType === "0") {
          _this.moduleDisabled = true;
          return "IsSearch";
        } else if (_this.form.serveType === "1") {
          _this.moduleDisabled = true;
          return "IsApprove";
        } else {
          _this.moduleDisabled = true;
          return "IsOther";
        }
      } else {
        // 新增
        if (_this.form.serveType === "0") {
          _this.moduleDisabled = false;
          return "IsSearch";
        } else if (_this.form.serveType === "1") {
          _this.moduleDisabled = false;
          return "IsApprove";
        } else {
          _this.moduleDisabled = true;
          return "IsOther";
        }
      }
    },
  },
  created() {},
  mounted() {
    this.initFn();
  },
  destroyed() {},
  methods: {
    // 默认请求
    // 请求子组件用到的公用接口
    initFn() {
      this.getServeType(); // 服务类型
      this.getServeObj(); // 服务对象
      this.getServeTheme(); // 服务主题
      this.getServeModule(this.form.serveType); // 服务组件

      // 传之组件
      this.prorData = {
        serveId: this.serveId,
        obj: this.selectObj.data,
        theme: this.selectTheme.data,
        infoFrom: this.infoFrom,
      };
    },

    // 切换 服务类型
    changeServeModule(type) {
      this.form.moduleType = "all";
      this.getServeModule(type);
    },

    // 显示弹框
    dialogShow(id, name, type) {
      this.show = true;
      this.loading = true;
      this.form.serveType = type;
      // 清空 详情对象
      this.infoFrom = {};

      setTimeout(() => {
        if (id) {
          this.title = name + "详情";
          this.getInfoData(id, name);
          this.disabled = true;
          this.moduleDisabled = true;
        } else {
          this.title = "新增服务";
          this.serveId = "";
          this.disabled = false;
          // 调用刷新表单方法
          this.$refs.formRule.refreshForm();
        }
        this.loading = false;
      }, 500);
    },

    // 服务类型
    getServeType() {
      this.$http
        .get("/hallServe/typeList")
        .then((res) => {
          res.data.resData.forEach((e) => {
            this.selectType.data.push({
              value: e.id + "",
              label: e.serveTypeName,
            });
          });
        })
        .catch(() => {
          this.$message.error("网络错误，服务类型接口请求失败！");
        });
    },

    // 服务对象
    getServeObj() {
      this.$http
        .get("/hallServe/targetList")
        .then((res) => {
          res.data.resData.forEach((e) => {
            this.selectObj.data.push({
              value: e.id + "",
              label: e.targetTypeName,
            });
          });
        })
        .catch(() => {
          this.$message.error("网络错误，服务类型接口请求失败！");
        });
    },

    // 服务主题
    getServeTheme() {
      let data = this.$qs.stringify({
        // 传入参数
        subjectName: "",
        pageNum: 0,
        pageSize: 999,
      });
      this.$http
        .post("/subject/subjectPageList", data)
        .then((res) => {
          res.data.resData.list.forEach((e) => {
            this.selectTheme.data.push({
              value: e.id + "",
              label: e.subjectName,
            });
          });
        })
        .catch(() => {
          this.$message.error("网络错误，服务类型接口请求失败！");
        });
    },

    // 服务组件 form.serveType = 0; 查询类 form.serveType = 1 审批类 组件
    getServeModule(type) {
      this.selectModule.data = [];
      this.$http
        .get("/hallServe/componentList?componentType=" + type)
        .then((res) => {
          res.data.resData.forEach((e) => {
            this.selectModule.data.push({
              value: e.id + "",
              label: e.interfaceUrl,
            });
          });
        })
        .catch(() => {
          this.$message.error("网络错误，服务类型接口请求失败！");
        });
    },

    // 保存（根据子组件信息调用）
    // 1、backData 中包含有 formType => one: 查询类 站内; two: 审批类站内; three: 站外
    // 2、保存成功之后，会生成一个 服务id:serveId;
    // 3、子组件操作中，如果 有 serveId; 此时的保存，应该调用 更新的接口
    getChildData(backData) {
      let arrObj = []; // 服务对象
      let arrTheme = []; // 服务主题

      // 转换 服务对象
      backData.obj.forEach((e) => {
        this.selectObj.data.forEach((i) => {
          if (e === i.value) {
            arrObj.push({ id: e, targetName: i.label });
          }
        });
      });

      // 转换 服务主题
      backData.theme.forEach((e) => {
        this.selectTheme.data.forEach((i) => {
          if (e === i.value) {
            arrTheme.push({ id: e, subjectName: i.label });
          }
        });
      });

      // 保存 第一项信息
      let data = this.$qs.stringify({
        // 传入参数
        serveName: backData.name,
        serveType: this.form.serveType,
        serveSubject: JSON.stringify(arrTheme),
        serveTarget: JSON.stringify(arrObj),
        componentId: this.form.moduleType === "all" ? "" : this.form.moduleType,
        recommend: backData.recommend === true ? 1 : 0,
        linkUrl: backData.linkUrl,
        mobileUrl: backData.mobileUrl,
        terminal: backData.terminal.join(","),
        fileId: backData.imgId,
        processDefId: backData.processDefId,
        processVersionId: backData.processVersionId,
        id: this.serveId,
      });

      // 如果存在 this.serveId,此时点击 保存，调用的是更新的方法
      if (this.serveId !== "") {
        this.updateServe(data, backData.formType);
        return;
      }

      this.$http
        .post("/hallServe/addServe", data)
        .then(({ data }) => {
          if (data.resCode === 0) {
            this.$message.success("服务基本信息保存成功！");
            this.$nextTick(() => {
              this.serveId = data.resData;
            });
            // 没有其他提交，则关闭窗口、刷新列表
            if (backData.formType !== "one") {
              this.show = false;
              this.serveId = "";
              this.infoFrom = {};
            }
            this.$parent.initPage();
          }
        })
        .catch(() => {
          this.$message.error("网络错误，服务基本信息保存接口请求失败！");
        });
    },

    // 更新
    updateServe(data, type) {
      this.$http
        .post("/hallServe/updateServe", data)
        .then(({ data }) => {
          if (data.resCode === 0) {
            this.$message.success("服务基本信息更新成功！");

            // 没有使用说明提交，则关闭窗口、刷新列表
            if (type !== "one") {
              this.show = false;
              this.serveId = "";
              this.infoFrom = {};
            }
            this.$parent.initPage();
          }
        })
        .catch(() => {
          this.$message.error("网络错误，服务基本信息更新接口请求失败！");
        });
    },

    // 点击 保存
    submitForm() {
      // 调用验证方法
      this.$refs.formRule.validateForm("ruleForm");
    },

    // 子组件关闭窗口
    closeDialog() {
      this.show = false;
      this.$emit("closeFn");
    },

    // 关闭大窗口
    closeBox() {
      this.show = false;
      this.serveId = "";
      this.infoFrom = {};
    },

    // 获取详情
    getInfoData(id) {
      this.$http
        .get("/hallServe/serveDetail?serveId=" + id)
        .then(({ data }) => {
          if (data.resCode === 0) {
            let obj = [];
            let theme = [];
            let logoData = data.resData.logo;
            let serveData = data.resData.serve;

            serveData.serveTargetList.forEach((e) => {
              obj.push(e.id + "");
            });

            serveData.serveSubjectList.forEach((e) => {
              theme.push(e.id);
            });

            if (logoData) {
              this.infoFrom.imgUrl = logoData.fileUrl;
              this.infoFrom.imgId = logoData.id;
              this.infoFrom.recommend =
                serveData.recommend === 1 ? true : false;
              this.infoFrom.serveId = serveData.id;
              this.infoFrom.formType =
                serveData.serveType === "0"
                  ? "two"
                  : serveData.serveType === "1"
                  ? "one"
                  : "three";
              this.infoFrom.name = serveData.serveName;
              this.infoFrom.obj = obj;
              this.infoFrom.theme = theme;
              this.infoFrom.processDefId = serveData.processDefId; // 服务Id
              this.infoFrom.processVersionId = serveData.processVersionId; // 流程版
              this.infoFrom.linkUrl = serveData.linkUrl;
              this.infoFrom.mobileUrl = serveData.mobileUrl;
              this.infoFrom.terminal = serveData.terminal;

              this.form.serveType = serveData.serveType;
              this.form.moduleType =
                serveData.componentId === "" ? "all" : serveData.componentId;
              this.serveId = serveData.id;
            }
          }
        })
        .catch(() => {
          this.$message.error("网络错误，服务类型接口请求失败！");
        });
    },

    // 调用子组件下的保存方法
    clickChildFn() {
      this.$refs.formRule.clickChildFn();
    },
  },
  watch: {
    infoFrom: {
      handler() {
        // 传之组件
        this.prorData = {
          serveId: this.serveId,
          obj: this.selectObj.data,
          theme: this.selectTheme.data,
          infoFrom: this.infoFrom,
        };
      },
      immediate: true,
    },
  },
  filters: {},
};
</script>

<style scoped>
.title {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f1f2f3;
  padding-bottom: 12px;
}

.title span {
  color: #409eff;
  font-size: 16px;
}
.el-form {
  padding-top: 20px;
}
</style>
